import PropTypes from 'prop-types';
import styles from './description.css';


const Description = ({
  text,
  className,
}) => (
  <div className={`${styles.container} ${className || ''}`}>
    {text}
  </div>
);

Description.propTypes = {
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
};

export default Description;
